<template>
  <button
    :type="type"
    class="transition-ease-in-out max-w-full font-[Lexend] text-base focus:outline-none focus-visible:outline-none disabled:pointer-events-none disabled:border-opacity-50 disabled:opacity-50"
    :class="[themes[theme], sizes[size]]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "CoreButtonBase",
  props: {
    theme: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    size: {
      default: "normal",
    },
  },
  data() {
    return {
      themes: {
        primary:
          "normal-case bg-accent rounded-xl text-white  text-base hover:shadow-button-hover hover:bg-primary-100",
        primaryTransparent:
          "rounded-md border-0 border  text-primary-blue bg-transparent hover:bg-neutral-200 normal-case",
        primaryLink:
          "rounded-md border-0 border text-primary-blue bg-transparent hover:bg-neutral-200 normal-case font-medium text-base ",
        white:
          "rounded-xl border-white border text-accent text-base bg-white hover:opacity-70 font-[Lexend]",
        whiteBorder:
          "rounded-md border-white border text-white bg-primary-100 hover:opacity-70",
        whiteTransparent:
          "rounded-md border-white border text-white bg-transparent hover:opacity-70",
        secondary:
          "rounded-xl bg-accent text-white text-base hover:opacity-70  font-[Lexend]",
        danger:
          "rounded-xl bg-danger-100 text-white text-base hover:opacity-70  font-[Lexend]",
        secondaryLight:
          "rounded-md bg-secondary-light text-neutral-40  font-semibold",
        secondaryUnavailable:
          "rounded-md bg-gray text-white  font-semibold pointer-events-none opacity-30",
        primaryLight:
          "rounded-md bg-primary-light text-white hover:opacity-70 font-bold",
        outlinePrimaryLight:
          "rounded-md bg-white text-primary-light border-2 border-primary-light border-opacity-20 hover:opacity-70 font-medium",
        disabled:
          "rounded-md bg-primary-100 text-white bg-opacity-20 pointer-events-none font-[Lexend]",
        unavailable:
          "rounded-md border-neutral-40 border text-neutral-40 bg-transparent pointer-events-none",
        outlineAccent:
          "!text-accent font-normal border border-accent rounded-xl text-base bg-white font-[Lexend]",
        filledAccent:
          "text-white font-normal border border-accent rounded-xl text-base bg-accent font-[Lexend]",
        link: "text-black text border-0 font-sm border font-[Lexend] hover:text-gray",
        accent:
          "bg-accent text-white rounded-lg border border-accent hover:bg-neutral-200",
        search:
          "bg-white text-accent rounded-xl border border-accent hover:border-[3px] transition-all ease-in",
        outlineSecondary:
          "bg-transparent text-accent border border-accent hover:opacity-70 font-light !text-sm rounded-xl",
      },
      sizes: {
        normal: "px-4 py-2",
        small: "px-2 py-0.5",
        custom: "px-8 py-2 lg:px-14 lg:py-4",
        mid: "px-[23px] py-[8px]",
        midAccount:
          "min-w-[200px] xs:min-w-[253px] xl:min-w-[132px] px-[23px] py-[8px]",
        midAccountDownload: "min-w-[253px] xl:min-w-[132px] px-[8px] py-[8px]",
        middle: "px-[27px] py-[13px]",
        search:
          "px-[6px] py-[7px] lg:px-[27px] lg:py-[12px] hover:lg:px-[25px] hover:lg:py-[10px] active:lg:px-[27px] active:lg:py-[12px] active:lg:border-0",
        none: "",
        customSearch: "px-[16px] py-[7px] h-[40px]",
      },
    };
  },
};
</script>
